let headerSearchInput = document.querySelector('.Header__Wrapper input[type="search"]'),
headerSearchIcon = document.querySelector('.Header__Wrapper .header__search-icon'); 
headerSearchInput.addEventListener('input', (e) => {
  if (e.currentTarget.value != '') {
    headerSearchIcon.classList.add('has-value')
  } else {
    headerSearchIcon.classList.remove('has-value')
  }
});
headerSearchIcon.addEventListener('click', () => {
  headerSearchIcon.classList.remove('has-value');
  headerSearchInput.value = '';
  headerSearchInput.dispatchEvent( new Event('input')); 
})


window.removeURLParameter = function(parameter) {
  //prefer to use l.search if you have a location/link object
  var url = window.location.href;
  var urlparts= url.split('?');   
  if (urlparts.length>=2) {
    
    var prefix= encodeURIComponent(parameter)+'=';
    var pars= urlparts[1].split(/[&;]/g);
    
    //reverse iteration as may be destructive
    for (var i= pars.length; i-- > 0;) {    
      //idiom for string.startsWith
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
        pars.splice(i, 1);
      }
    }
    
    url= urlparts[0]+'?'+pars.join('&');
    return url;
  } else {
    return url;
  }
}
let sticky =  document.querySelector('sticky-atc')

let variantsJson = JSON.parse(document.querySelector('[data-variants-discontinued-json]').textContent);
let selectedVarID = document.querySelector('[name="id"]').value;
if (variantsJson[`${selectedVarID}`].discontinued) {
  sticky.style.visibility = 'hidden'
}

// product variants discontinued functionality
let variantsBtns = document.querySelectorAll('.ProductForm__Option input');
variantsBtns.forEach(btn => {
  btn.addEventListener('click', (e) => {
    setTimeout(() => {
      let variantsJson = JSON.parse(document.querySelector('[data-variants-discontinued-json]').textContent);
      let selectedVarID = document.querySelector('[name="id"]').value;
      let docData = document.querySelectorAll('.Product-affirm-data, .metafield-data-additional, .product--button-wrapper, .ProductMeta__ShareButtons, .product-info-tabination, .ProductMeta__PriceList');
      let discontinuedEle = document.querySelector('.ProductMeta__discontinued');
      let sticky =  document.querySelector('sticky-atc')
      if (variantsJson[`${selectedVarID}`].discontinued) {
        docData.forEach(ele => ele.classList.add('d-none'));
        (!discontinuedEle.classList.contains('is_product_discontinued')) && discontinuedEle.classList.remove('d-none')
        sticky.style.visibility = 'hidden'
      } else {
        docData.forEach(ele => ele.classList.remove('d-none'));
        (!discontinuedEle.classList.contains('is_product_discontinued')) && discontinuedEle.classList.add('d-none')
        sticky.style.visibility = 'unset'
      }

    }, 10);
  })
})
window.addEventListener('DOMContentLoaded', () => {




  window.swiperPdpThumbnail = new Swiper(".swiper--thumbnails", {
    direction: "vertical",
    slidesPerView: 4,
    spaceBetween: 0,
    autoHeight: true,
    loop: false,
    grabCursor: true,
    speed: 800,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
        nextEl: ".swiper--thumbnails-nav.swiper-button-next",
        prevEl: ".swiper--thumbnails-nav.swiper-button-prev",
    },
  })

  document.querySelector('.search__uniq').addEventListener('click', function () { document.querySelector('.customSearch').classList.add('is-show')})
  document.querySelector('.closeCustomSearch').addEventListener('click',function (e) {  e.preventDefault();  document.querySelector('.customSearch').classList.remove('is-show')
  document.querySelector("input.header__search-input.Search__Input").value = ''
  document.querySelector(".Search__Results").setAttribute('aria-hidden', 'true')
  })
  document.querySelector('.Search__SearchBar').addEventListener('keypress', function (e) {
    if (e.key === 'Enter') {
      document.querySelector('.customSearchFrom').submit()
    }
  });


 

})

let domEvents = ['DOMContentLoaded','resize'];
domEvents.forEach(e => {
  window.addEventListener(e, () => {
    let buyBtnWrapper = document.querySelector('.product--button-wrapper ');
    if(buyBtnWrapper) {
      buyBtnWrapper.style.pointerEvents = null;
    }
    var topHeight = window.pageYOffset + document.querySelector('.highlight-section')?.getBoundingClientRect().top;
    window.addEventListener('scroll', () => {
      if (window.screen.width <= 1007) {
        let atcOffset = (document.querySelector('#shopify-section-header').clientHeight - 150) - document.querySelector('.ProductForm').getBoundingClientRect().bottom;
        if (atcOffset >= 0) {
          document.querySelector('body.template-product').classList.add('sticky-add-to-cart');
        } else {
          document.querySelector('body.template-product').classList.remove('sticky-add-to-cart');
        } 
      } else {
        document.querySelector('body.template-product').classList.remove('sticky-add-to-cart');
      }
    })
  })
})


